// src/components/products/ProductForm/Step1SelectProductType.jsx

import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import FormInput from "../../inputs/FormInput";
import useGetProductTypes from "../../../hooks/productTypes/useGetProductTypes";

/**
 * Step 1: Select Product Type
 */
const Step1SelectProductType = ({ formData, setFormData, errors = {} }) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    // Get product types
    const { productTypes, isLoading } = useGetProductTypes();

    const handleProductTypeChange = (e) => {
        const selectedId = e.target.value;

        // Find from productTypes.items (check your hook structure)
        const items = productTypes?.items || productTypes || [];
        const selectedType = items.find(type => type.id === selectedId);

        setFormData({
            ...formData,
            product_type_id: selectedId,
            selectedProductType: selectedType, // Store full object for reference
        });
    };

    // Extract items from productTypes (adjust based on your hook's return structure)
    const options = productTypes?.items || productTypes || [];

    return (
        <Paper sx={{ p: 4 }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                    {isArabic ? 'اختر نوع المنتج' : 'Select Product Type'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {isArabic
                        ? 'اختر نوع المنتج الذي تريد إنشاءه (Tour أو Transfer)'
                        : 'Choose the type of product you want to create (Tour or Transfer)'}
                </Typography>
            </Box>

            <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                    <FormInput
                        label={isArabic ? 'نوع المنتج' : 'Product Type'}
                        type="select"
                        name="product_type_id"
                        value={formData.product_type_id || ''}
                        onChange={handleProductTypeChange}
                        required
                        disabled={isLoading}
                        error={!!errors.product_type_id}
                        helperText={errors.product_type_id}
                        options={options}
                    />
                </Grid>
            </Grid>

            {/* Product Type Description/Info */}
            {formData.selectedProductType && (
                <Box
                    sx={{
                        mt: 3,
                        p: 2,
                        backgroundColor: 'primary.light',
                        borderRadius: 2,
                        opacity: 0.9,
                    }}
                >
                    <Typography variant="body2" color="primary.contrastText">
                        {isArabic
                            ? `تم اختيار: ${formData.selectedProductType.name?.ar || formData.selectedProductType.name}`
                            : `Selected: ${formData.selectedProductType.name?.en || formData.selectedProductType.name}`}
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

export default Step1SelectProductType;
